export const environment = {
  production: false,
  hubClientId: '6194d462-eed7-47f7-afd1-3a4834c9fddf',
  API_BASE: 'https://uat-auth.wolop.app',
  hubUrl: 'https://uat-hub.wolop.app/v1/core/dashboard',
  brandingLogoUrl: 'https://configuration.wolop.app/api/v1/configuration/branding/logo',
};
